<template>
  <div id="template">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        ref="queryForm"
        :model="queryParams"
        label-width="80px"
        style="padding: 0 5px"
      >
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="编码类型：">
                <el-select
                  clearable
                  v-model="queryParams.productCodeType"
                  placeholder="请选择编码类型"
                  class="input"
                  size="small"
                >
                  <el-option
                    v-for="(value, key, index) in dictData['productCodeType']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                    >{{ value.label }}
                  </el-option>
                </el-select>
              </el-form-item>
            </div></el-col
          >

          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="是否使用：">
                <el-select
                  clearable
                  v-model="queryParams.isUse"
                  placeholder="请选择编码类型"
                  class="input"
                  size="small"
                >
                  <el-option :key="index" label="是" value="1">是</el-option>
                  <el-option label="否" value="0">否</el-option>
                </el-select>
              </el-form-item>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="操作时间：" prop="dateValue">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="operateTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24"
            ><div class="grid-content bg-purple">
              <div style="text-align: right; margin: auto; padding-top: 10px">
                <el-button size="small" type="primary" @click="getList"
                  >搜索</el-button
                >
                <el-button size="small" @click="resetForm">重置</el-button>
              </div>
            </div></el-col
          >
        </el-row>
      </el-form>
    </div>
    <div class="form-body">
      <div class="form-body-header">
        <div class="left" style="margin: 0 16px 0 0">
          <el-upload
            class="upload-task"
            action=""
            ref="uploadControl1"
            :http-request="uploadFile1"
            :on-success="(value) => handleUploadSuccess1(value)"
            :show-file-list="false"
            :file-list="fileList1"
            :before-upload="beforeUpload"
            :limit="1"
            size="small"
          >
            <el-button type="primary" size="small">导入EAN</el-button>
          </el-upload>
        </div>
        <div class="left">
          <el-upload
            class="upload-task"
            action=""
            ref="uploadControl2"
            :http-request="uploadFile2"
            :on-success="(value) => handleUploadSuccess1(value)"
            :show-file-list="false"
            :file-list="fileList1"
            :before-upload="beforeUpload"
            :limit="1"
            size="small"
          >
            <el-button type="primary" size="small">导入UPC</el-button>
          </el-upload>
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
      <el-table
        id="outTable"
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="productCodeType"
          label="编码类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="productCode"
          label="商品编码"
          align="center"
        ></el-table-column>
        <el-table-column prop="totalNum" label="是否使用" align="center">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.isUse == "0" ? "否" : "是"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operNo" label="操作人" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.nickName ? scope.row.nickName : scope.row.operNo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tTime" label="操作时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
         :page-sizes="[10, 20, 50, 100]"
      />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from "@/components/common/Breadcrumb";
import { listPlat ,importPlatCodeEAN , importPlatCodeUPC } from "@/api/order/code";
import { mapGetters } from "vuex";
import dayjs from "dayjs"

export default {
  name: "codeManage",
  components: { Breadcrumb },
  data() {
    return {
      selectValue1: "",
      total: 0,
      currentPage: 1,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        productCodeType: '',
        isUse: null,
      },
      form: {
        flagCode: '',
        factoryCode: '',
        productCodeType: '',
        totalNum: ''
      },
      operateTime: [],
      dateValue: [],
      tableData: [],
      eanVisible: false,
      upcVisible: false,
      rules: {
        flagCode: [{required: true, message: '请选择旗码', trigger: 'change'}],
        factoryCode: [{required: true, message: '请输入工厂代码', trigger: 'blur'}],
        totalNum: [{required: true, message: '请输入生成数量', trigger: 'blur'}],
      },
      maxNum: 0,
      detailVisible: false,
      codeData: [],
      fileList1: [],
    };
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
  },
  created() {
    this.getList();
  },
  methods: {
    getList(){
       let params = Object.assign({}, this.queryParams)
       if (this.operateTime && this.operateTime.length > 0) {
        params["beginTime"] = dayjs(this.operateTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.operateTime[1]).format("YYYY-MM-DD")
      }
      listPlat(params).then((result)=>{
        this.tableData = result.rows
        this.total = result.total
      })
    },
    resetForm(){
       this.queryParams = Object.assign(this.queryParams,{
        productCodeType: '',
        factoryCode: '',
        isUse: null,
      })
      
      this.operateTime = []
    },
    async handleShowDetail(row){
      let result = await listDet({codeKey: row.codeKey})//codeKey编码
      this.codeData = result.rows
      this.detailVisible = true
    },
    handleCreateEan(){
      this.form.productCodeType = 'EAN'
      if(this.form.factoryCode.length !== 6){
        this.msgError('EAN编码只能6位')
        return
      }
       this.$refs["form"].validate(valid => {
        if(valid){
          addCode(this.form).then((res) => {
            if (res.code == 200) {
              this.msgSuccess("EAN生成成功");
              this.getList()
              this.eanVisible = false
            }
          }).catch(err => {
          });
        } else{
          this.$message.warning("信息填写不完整！");
        }

      })
    },
    handleCreateUpc(){
      this.form.productCodeType = 'UPC'
      if(this.form.factoryCode.length !== 5){
        this.msgError('UPC编码只能5位')
        return
      }
       this.$refs["form"].validate(valid => {
        if(valid){
          addCode(this.form).then((res) => {
            if (res.code == 200) {
              this.msgSuccess("UPC生成成功");
              this.getList()
              this.upcVisible = false
            }
          }).catch(err => {
          });
        } else{
          this.$message.warning("信息填写不完整！");
        }

      })
    },
    handleCreateFactroyCode(type){
       var code = ('00000' + Math.floor(Math.random() * 99999)).slice(-5)
       if(type == 'EAN'){
         code = ('000000' + Math.floor(Math.random() * 999999)).slice(-6)
       }
       this.form.factoryCode = code
    },
    handleOperateStatus(row){
      editFlag({
        codeKey: row.codeKey,
        isUse: row.isUse == '1' ? '0' : '1'
      })
      this.getList()
      this.msgSuccess("操作成功")
    },

      handleUploadSuccess1(response) {
      this.$refs.uploadControl1.clearFiles()
      this.$refs.uploadControl2.clearFiles()
    },
     async uploadFile1(file) {
      this.startLoading()
      let formData = new FormData()
      formData.append("file", file.file)
      importPlatCodeEAN(formData).then((response) => {
        if (response.code === 200) {
          this.getList()
          this.msgSuccess("导入成功")
          this.endLoading()
        } else {
          this.msgError(response.msg)
          this.endLoading()
        }
      }).catch(()=>{
        this.endLoading()
      })
    },
    async uploadFile2(file) {
      this.startLoading()
      let formData = new FormData()
      formData.append("file", file.file)
      importPlatCodeUPC(formData).then((response) => {
        if (response.code === 200) {
          this.getList()
          this.msgSuccess("导入成功")
          this.endLoading()
        } else {
          this.msgError(response.msg)
          this.endLoading()
        }
      }).catch(()=>{
        this.endLoading()
      })
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error("文件超过2MB")
      }
      return isLt2M
    },

  },
  mounted() {},
};
</script>

<style scoped>
@import "../../../assets/css/product.css";
#ready-release {
  width: 100%;
}
.detailForm {
  padding-top: 5px;
  margin-left: 85px;
  width: 50%;
  height: auto;
  margin-bottom: 8px;
}
.detailForm .el-form-item,
.sea_cont {
  margin-bottom: 10px !important;
}
.double_item .el-form-item {
  margin-bottom: 0px !important;
}
.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.form-content {
  background: #ffffff;
}
</style>
